import {
  Component,
  TemplateRef,
  ViewChild,
  ElementRef
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  modalRef: BsModalRef;
  public newForm: boolean;
  public request: string;
  public requestType: string;

  @ViewChild('template', { static: true }) public templateref: TemplateRef<any>;
  @ViewChild('nodeInput', { static: true }) nodeInput: ElementRef<HTMLElement>;

  constructor(private modalService: BsModalService) { }

  closeModal(): void {
    this.modalService.hide();
  }

  public openModalWithClass(): void {
    this.modalRef = this.modalService.show(
      this.templateref,
      Object.assign({}, { class: 'modal-lg', ignoreBackdropClick: true })
    );
  }
}
